export default {
  LOGIN_SUCCESS: 'Xlogin:loginSuccess',
  LOGIN_OUT: 'Xlogin:logoutSuccess',
  CHECK_LOGIN: 'Xlogin:checkLogin'
}
